<template>
  <div>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
      <el-form-item label="旧密码" prop="old_password">
        <el-input type="password" v-model="ruleForm.old_password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input type="password" v-model="ruleForm.new_password" autocomplete="off" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="new_password_repeat">
        <el-input type="password" v-model="ruleForm.new_password_repeat" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>
<script>
    export default {
        name: 'ChangePassword',
        data() {
            var validateOldPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入旧密码'));
                }else
                {
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else {
                        if (value.length < 8) {
                          return callback('密码不少于8位')
                        }
                        if (value.length > 20) {
                          return callback('密码不大于20位')
                        }
                        const regex1 = /^\d+$/
                        const regex2 = /^[A-Za-z]+$/
                        const regex3 =
                          /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$/
                        if (regex1.test(value)) {
                          return callback('设置8至20位包含大小写字母、数字、特殊符号的密码')
                        } else if (regex2.test(value)) {
                          return callback('设置8至20位包含大小写字母、数字、特殊符号的密码')
                        } else if (regex3.test(value)) {
                          return callback('设置8至20位包含大小写字母、数字、特殊符号的密码')
                        } else if (/^[A-Za-z\d]+$/.test(value)) {
                          return callback('设置8至20位包含大小写字母、数字、特殊符号的密码')
                        }
                        if (this.ruleForm.new_password_repeat !== '') {
                           this.$refs.ruleForm.validateField('new_password_repeat');
                        }
                         callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.new_password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    old_password: '',
                    new_password: '',
                    new_password_repeat: '',
                },
                rules: {
                    old_password: [
                        {validator: validateOldPass, trigger: 'blur'}
                    ],
                    new_password: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    new_password_repeat: [
                        {validator: validatePass2, trigger: 'blur'}
                    ]
                }
            };
        },
        mounted() {
            this.getDetail();
        },
        methods: {
			
            getDetail(){
               alert('密码强度不行，请重新修改密码');
            },
            submitForm(formName) {
               this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.updatePassword(this.ruleForm).then(res => {
                            if (res.code !== 0)
                                this.$message.success('修改密码成功！');
                            else
                                this.$message.error(res.message);
                        })
                    } else {
                        this.$message.error('服务器内部错误');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$http.resetPassword({'username': this.$store.getters.getUserInfo.username}).then(res => {
                    if (res.code !== 0)
                        this.$message.success('重置密码成功,默认密码为ABC@abc123');
                    else
                        this.$message.error(res.message);
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/User/ChangePassword.vue